import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, errorTranslate } from "./util";
import i18n from "../i18n";
import {
  applyLcaDropdownCache,
  writeLcaDropdownCache,
  lcaCacheKeyGlobal,
  lcaCacheKeyGlobalI18n,
  lcaCacheKeyProduct,
  lcaCacheKeyTransportPackaging,
} from "./lcaDropdownCache";
export const getInventoriesPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/supplies/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data;
  } else return [];
};

export const getInventoriesDropdown = async ({ setDropdown }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=supplies",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data.map((supply) => {
          supply.value = supply.name;
          return supply;
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getLocationDropdown = ({ setDropdown }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data.map((size) => {
          size.value = size.name;
          return size;
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductDropdown = ({ setDropdown }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data.map((size) => {
          size.value = size.name;
          return size;
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getRoles = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/roles",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data.map((size) => {
          size.value = size.name;
          return size;
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getMeansOfTransport = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/transport",
    headers: {},
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "product_type_name_en" : "product_type_name";
  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTravelCommuteData = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/travel-commute-data",
    headers: {},
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCountryHotel = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hiot-hotel",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "country_code_en" : "country_code";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHotelData = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/travel-hotel-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en"
          ? "visiting_country_name_en"
          : "visiting_country_name";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteMethod = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hiot-waste",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size.product_type_name;
            size.name = size.product_type_name;
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGasRefrigerant = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/refrigerant",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSuppresantIndustrialData = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/suppressant-industrial-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "name_en" : "name";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHeatingSource = ({ businessSizeList, setBusinessSizeList }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/fuel",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setBusinessSizeList(
        response.data.data
          .map((size) => {
            size.value = size.name;
            // if (!size.value.includes("("))
            size.value = size.name + " " + size.physical_unit + "";
            // else {
            //   size.value = size.name.replace(/\((.+?)\)/g, "("+size.physical_unit+")")
            // }
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getExternalPowerSource = ({
  businessSizeList,
  setBusinessSizeList,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/external-power-source",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "product_type_name_en" : "product_type_name";
      setBusinessSizeList(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            // if (!size.value.includes("("))
            size.value = size[hiotName] + " " + size.physical_unit + "";
            // else {
            //   size.value = size.name.replace(/\((.+?)\)/g, "("+size.physical_unit+")")
            // }
            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterSourceData = ({
  dropdownWaterData,
  setDropdownWaterData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/water-source-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "material_name_en" : "material_name";
      setDropdownWaterData(
        response.data.data
          .map((water) => {
            water.value = water[hiotName];
            water.name = water[hiotName];
            return water;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryMaterialData = ({
  dropdownData,
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-material-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "material_en" : "material";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryPackagingData = ({
  dropdownData,
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-packaging-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "packaging_en" : "packaging";
      setDropdownData(
        response.data.data
          .map((packaging) => {
            packaging.value = packaging[hiotName];
            packaging.name = packaging[hiotName];

            return packaging;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryMachineData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-machine-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((machine) => {
            machine.value = machine[hiotName];
            machine.name = machine[hiotName];

            return machine;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryBuildingData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-building-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((building) => {
            building.value = building[hiotName];
            building.name = building[hiotName];

            return building;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryServiceData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-service-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((service) => {
            service.value = service[hiotName];
            service.name = service[hiotName];

            return service;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

function compare(a, b) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
}

export const getHiotCategory = ({
  businessSizeList,
  setBusinessSizeList,
  country,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hiot/" + country,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "product_type_name_en" : "product_type_name";

  axios(config)
    .then(function (response) {
      // console.log(response.data.data.map((size)=>{
      //       size.value = size.product_type_name
      //       return size
      //   }).sort(compare));
      if (response.data.data.length > 0) {
        setBusinessSizeList((data) =>
          response.data.data
            .map((size) => {
              // console.log(size)
              size.value = size[hiotName];
              return size;
            })
            .sort(compare),
        );
      } else {
        setBusinessSizeList([{ id: "abcd", value: "-", name: "-" }]);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getMaterial = ({ businessSizeList, setBusinessSizeList }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/material",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log("material data", response.data.data);
      setBusinessSizeList(
        response.data.data.map((size) => {
          // console.log(size)
          size.value = size.name;
          return size;
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const searchVehicle = ({ query, setDropdown, loading, setLoading }) => {
  const config = {
    method: "get",
    url:
      baseUrl + "/api/business/vehicle/search?name=" + (!query ? "a" : query),
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };
  if (loading) {
    setLoading("load");
  }
  axios(config)
    .then(function (response) {
      if (loading) setLoading("success");
      if (response.data.data.results.length > 0)
        setDropdown(
          response.data.data.results.map((result, i) => {
            return {
              value: result["Cn"] + ", " + result["Mk"] + ", " + result["Year"],
              id: i,
              emission: result["Ewltp (g/km)"],
            };
          }),
        );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteMaterial = async ({
  setDropdown = function () {
    return;
  },
  setDisposalDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/waste-material",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "surplus_material_en" : "surplus_material";
      const disposalName =
        getLanguage() === "en" ? "current_disposal_en" : "current_disposal";

      const uniqueSupplies = new Set(
        response.data.data.map((supply) => supply[hiotName]),
      );
      const uniqueDisposals = new Set(
        response.data.data.map((supply) => supply[disposalName]),
      );

      setDropdown(
        [...uniqueSupplies].map((supply) => {
          const matchingSupply = response.data.data.find(
            (item) => item[hiotName] === supply,
          );
          return {
            value: supply,
            name: supply,
            ...matchingSupply,
          };
        }),
      );

      setDisposalDropdown(
        [...uniqueDisposals].map((disposal) => {
          const matchingDisposal = response.data.data.find(
            (item) => item[disposalName] === disposal,
          );
          return {
            value: disposal,
            name: disposal,
            ...matchingDisposal,
          };
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteDisposalMethod = async ({ setDisposalDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/waste-disposal-method",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const disposalName =
        getLanguage() === "en" ? "current_disposal_en" : "current_disposal";

      const uniqueDisposals = new Set(
        response.data.data.map((supply) => supply[disposalName]),
      );

      setDisposalDropdown(
        [...uniqueDisposals].map((disposal) => {
          const matchingDisposal = response.data.data.find(
            (item) => item[disposalName] === disposal,
          );
          return {
            value: disposal,
            name: disposal,
            ...matchingDisposal,
          };
        }),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getOtherVehicleData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/stationary-combustion-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((otherVehicle) => {
            otherVehicle.value = otherVehicle[hiotName];
            otherVehicle.name = otherVehicle[hiotName];
            return otherVehicle;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportDeliveriesData = ({
  dropdownData,
  setDropdownData = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("transport-deliveries-data");
  if (applyLcaDropdownCache(_lcaKey, setDropdownData)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/transport-deliveries-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      const _data = response.data.data
        .map((transport) => {
          transport.value = transport[hiotName];
          transport.name = transport[hiotName];

          return transport;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdownData(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportCountryData = ({ dropdownData, setDropdownData }) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("country-transport-data");
  if (applyLcaDropdownCache(_lcaKey, setDropdownData)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/country-transport-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "country_en" : "country";
      const _data = response.data.data
        .map((transport) => {
          transport.value = transport[hiotName];
          transport.name = transport[hiotName];

          return transport;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdownData(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportFuelTypeData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/fuel-transport-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((transport) => {
            transport.value = transport[hiotName];
            transport.name = transport[hiotName];

            return transport;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryProductDropdown = ({
  inventoryDropdown,
  setInventoryDropdown = function () {
    return;
  },
  setInventoryNicknames = function () {
    return;
  },
  setInventoryQty = function () {
    return;
  },
  materialList = null,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-product-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (materialList === null || materialList.includes(key)) {
          if (Array.isArray(values)) {
            values.forEach((value) => {
              if (!uniqueValues.has(value)) {
                uniqueValues.add(value);
                dropdownOptions.push({ value, label: value });
              } else {
                removedValues.push(value);
              }
            });
          }
        }
      }

      setInventoryDropdown(dropdownOptions);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames,
      )) {
        if (materialList === null || materialList.includes(material)) {
          if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
            continue;
          }

          for (const [key, value] of Object.entries(nicknamesObj)) {
            if (Array.isArray(value)) {
              if (!uniqueNicknameValues[key]) {
                uniqueNicknameValues[key] = [];
              }
              uniqueNicknameValues[key].push(...value);
            }
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setInventoryNicknames(dropdownNicknames);

      const dropdownQty = [];
      const uniqueQtyValues = {};

      for (const [material, qtyObj] of Object.entries(response.data.qty)) {
        if (materialList === null || materialList.includes(material)) {
          if (typeof qtyObj !== "object" || Array.isArray(qtyObj)) {
            continue;
          }

          for (const [key, value] of Object.entries(qtyObj)) {
            if (Array.isArray(value)) {
              if (!uniqueQtyValues[key]) {
                uniqueQtyValues[key] = [];
              }
              uniqueQtyValues[key].push(...value);
            }
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueQtyValues)) {
        const labelValues = label.split(" & ");
        const labelMaterial = labelValues[0];
        const labelNickname = labelValues[1];
        const [value] = values;
        dropdownQty.push({ labelMaterial, labelNickname, values: value });
      }
      setInventoryQty(dropdownQty);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterProductDropdown = ({
  productDropdown,
  setProductDropdown = function () {
    return;
  },
  setWasteWaterDropdown = function () {
    return;
  },
  setNicknameDropdown = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-water-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];
      const dropdownWaste = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
              if (value === "Spildevand (kg)" || value === "Waste water (kg)") {
                dropdownWaste.push({ value, label: value });
              }
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setProductDropdown(dropdownOptions);
      setWasteWaterDropdown(dropdownWaste);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames,
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setNicknameDropdown(dropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterCompanyDropdown = ({
  productDropdown,
  id,
  setProductDropdown = function () {
    return;
  },
  setSymbioticDropdown = function () {
    return;
  },
  setNicknameDropdown = function () {
    return;
  },
  setSymbioticNicknameDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/water-company-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      id: id,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames,
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setNicknameDropdown(dropdownNicknames);

      const symbioticDropdownNicknames = [];
      const symbioticUniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.symbiotic_nicknames,
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!symbioticUniqueNicknameValues[key]) {
              symbioticUniqueNicknameValues[key] = [];
            }
            symbioticUniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(
        symbioticUniqueNicknameValues,
      )) {
        symbioticDropdownNicknames.push({ label, value: [...new Set(values)] });
      }
      setSymbioticNicknameDropdown(symbioticDropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSurplusProductDropdown = ({
  surplusDropdown,
  setSurplusDropdown = function () {
    return;
  },
  setSurplusNicknames = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-surplus-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setSurplusDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames,
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setSurplusNicknames(dropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSurplusProductIngoingDropdown = ({
  surplusDropdown,
  setSurplusDropdown = function () {
    return;
  },
  setSurplusNicknames = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-surplus-ingoing-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setSurplusDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames,
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setSurplusNicknames(dropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductIngoingDropdown = ({
  inventoryDropdown,
  setNameDropdown = function () {
    return;
  },
  setInvoiceNumDropdown = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-ingoing-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setNameDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownInvNum = [];
      const uniqueInvNumValues = {};

      for (const [material, invNumsObj] of Object.entries(
        response.data.invoiceNum,
      )) {
        if (typeof invNumsObj !== "object" || Array.isArray(invNumsObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(invNumsObj)) {
          if (Array.isArray(value)) {
            if (!uniqueInvNumValues[key]) {
              uniqueInvNumValues[key] = [];
            }
            uniqueInvNumValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueInvNumValues)) {
        dropdownInvNum.push({ label, value: [...new Set(values)] });
      }

      setInvoiceNumDropdown(dropdownInvNum);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductOutgoingDropdown = ({
  inventoryDropdown,
  setNameDropdown = function () {
    return;
  },
  setInvoiceNumDropdown = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-outgoing-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setNameDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownInvNum = [];
      const uniqueInvNumValues = {};

      for (const [material, invNumsObj] of Object.entries(
        response.data.invoiceNum,
      )) {
        if (typeof invNumsObj !== "object" || Array.isArray(invNumsObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(invNumsObj)) {
          if (Array.isArray(value)) {
            if (!uniqueInvNumValues[key]) {
              uniqueInvNumValues[key] = [];
            }
            uniqueInvNumValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueInvNumValues)) {
        dropdownInvNum.push({ label, value: [...new Set(values)] });
      }

      setInvoiceNumDropdown(dropdownInvNum);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductTravelDropdown = ({
  inventoryDropdown,
  setNameDropdown = function () {
    return;
  },
  setInvoiceDate = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-travel-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setNameDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownDate = [];
      const uniqueDateValues = {};

      for (const [material, invNumsObj] of Object.entries(
        response.data.invoiceDate,
      )) {
        if (typeof invNumsObj !== "object" || Array.isArray(invNumsObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(invNumsObj)) {
          if (Array.isArray(value)) {
            if (!uniqueDateValues[key]) {
              uniqueDateValues[key] = [];
            }
            uniqueDateValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueDateValues)) {
        dropdownDate.push({ label, value: [...new Set(values)] });
      }

      setInvoiceDate(dropdownDate);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getUsePhaseDropdown = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/use-phase-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGwpDropdown = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/gwp-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIndirectEnergyDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/indirect-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIndirectProcessDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/indirect-process-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIntermediateSourceDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/intermediate-source-used",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductFinalTreatmentDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/final-treatment-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPackagingMaterialList = ({
  dropdownData,
  setDropdownData,
  setTotalWeight,
  id,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/packaging-material-list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdownData(
        response.data.data
          .map((material) => {
            return {
              value: material,
              name: material,
            };
          })
          .sort(compare),
      );
      setTotalWeight(response.data.total_weight);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getDisassemblyComponentList = ({
  dropdownData,
  setDropdownData,
  setWeight,
  setList,
  id,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/disassembly-component-list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdownData(
        response.data.data
          .map((material) => {
            return {
              value: material,
              name: material,
            };
          })
          .sort(compare),
      );
      setWeight(response.data.total_weight);
      setList(response.data.total_list);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryIngoingPackagingDropdown = ({
  inventoryDropdown,
  businessId,
  setInventoryDropdown = function () {
    return;
  },
  setInventoryNicknames = function () {
    return;
  },
  setInventoryQty = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-ingoing-packaging-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business: businessId,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setInventoryDropdown(dropdownOptions);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames,
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setInventoryNicknames(dropdownNicknames);

      const dropdownQty = [];
      const uniqueQtyValues = {};

      for (const [material, qtyObj] of Object.entries(response.data.qty)) {
        if (typeof qtyObj !== "object" || Array.isArray(qtyObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(qtyObj)) {
          if (Array.isArray(value)) {
            if (!uniqueQtyValues[key]) {
              uniqueQtyValues[key] = [];
            }
            uniqueQtyValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueQtyValues)) {
        const labelValues = label.split(" & ");
        const labelMaterial = labelValues[0];
        const labelNickname = labelValues[1];
        const [value] = values;
        dropdownQty.push({ labelMaterial, labelNickname, values: value });
      }
      setInventoryQty(dropdownQty);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductIntermediateSoldSourcesDropdown = ({
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/intermediate-sold-sources-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductIndirectEmitCo2Dropdown = ({ setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/indirect-emit-co2-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getFuelVehicleDropdown = ({
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/fuel-electric-vehicle-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getRegisteredVehicleTypesDropdown = ({
  businessId,
  setDropdownData = function () {
    return;
  },
}) => {
  // Fetch data from both FuelVehicle and NonFuelVehicle APIs
  const fuelVehicleConfig = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/fuel-reg-vehicle",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const nonFuelVehicleConfig = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/reg-vehicle",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  // Use Promise.all to fetch both APIs simultaneously
  Promise.all([axios(fuelVehicleConfig), axios(nonFuelVehicleConfig)])
    .then(function ([fuelResponse, nonFuelResponse]) {
      const vehicleTypes = new Set(); // Use Set to ensure uniqueness
      const dropdownItems = [];

      // Process FuelVehicle data - extract fuel_type
      if (fuelResponse.data.data && Array.isArray(fuelResponse.data.data)) {
        fuelResponse.data.data.forEach((vehicle) => {
          if (
            vehicle.fuel_type &&
            typeof vehicle.fuel_type === "object" &&
            vehicle.fuel_type.value
          ) {
            const fuelType = vehicle.fuel_type.value;
            if (!vehicleTypes.has(fuelType)) {
              vehicleTypes.add(fuelType);
              dropdownItems.push({
                id: `fuel_${fuelType}`,
                name: fuelType,
                value: fuelType,
                source: "fuel_vehicle",
              });
            }
          } else if (
            vehicle.fuel_type &&
            typeof vehicle.fuel_type === "string"
          ) {
            const fuelType = vehicle.fuel_type;
            if (!vehicleTypes.has(fuelType)) {
              vehicleTypes.add(fuelType);
              dropdownItems.push({
                id: `fuel_${fuelType}`,
                name: fuelType,
                value: fuelType,
                source: "fuel_vehicle",
              });
            }
          }
        });
      }

      // Process NonFuelVehicle data - extract vehicle_type
      if (
        nonFuelResponse.data.data &&
        Array.isArray(nonFuelResponse.data.data)
      ) {
        nonFuelResponse.data.data.forEach((vehicle) => {
          if (
            vehicle.vehicle_type &&
            typeof vehicle.vehicle_type === "object" &&
            vehicle.vehicle_type.value
          ) {
            const vehicleType = vehicle.vehicle_type.value;
            if (!vehicleTypes.has(vehicleType)) {
              vehicleTypes.add(vehicleType);
              dropdownItems.push({
                id: `nonfuel_${vehicleType}`,
                name: vehicleType,
                value: vehicleType,
                source: "non_fuel_vehicle",
              });
            }
          } else if (
            vehicle.vehicle_type &&
            typeof vehicle.vehicle_type === "string"
          ) {
            const vehicleType = vehicle.vehicle_type;
            if (!vehicleTypes.has(vehicleType)) {
              vehicleTypes.add(vehicleType);
              dropdownItems.push({
                id: `nonfuel_${vehicleType}`,
                name: vehicleType,
                value: vehicleType,
                source: "non_fuel_vehicle",
              });
            }
          }
        });
      }

      // Sort the dropdown items alphabetically
      dropdownItems.sort((a, b) => a.name.localeCompare(b.name));

      setDropdownData(dropdownItems);
    })
    .catch(function (error) {
      console.log("Error fetching registered vehicle types:", error);
      // Fallback to empty array if API fails
      setDropdownData([]);
    });
};

export const getHotelLocationDropdown = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hotel-location-dropdown",
    headers: {},
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((item) => {
            return {
              ...item,
              value: item[hiotName],
              name: item[hiotName],
              id: item.id,
            };
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProcessingIntermediateDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/process-intermediate-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProcessingFinalTreatmentDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/processing-final-treatment",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompDirectEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("comp-direct-energy-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-direct-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompUseGwpDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("comp-use-gwp-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-use-gwp-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompIndirectEmitDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("comp-indirect-emit-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-indirect-emit-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompIndirectEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("comp-indirect-energy-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-indirect-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompIntermediateEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("comp-intermediate-energy-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-intermediate-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompFinalTreatmentDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-final-treatment-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdIndirectEmitDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-indirect-emit-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const customCompare = (a, b) => {
        // If both are "Process missing" or neither is, use normal comparison
        if (
          (a[hiotName] === "Process missing") ===
          (b[hiotName] === "Process missing")
        ) {
          return compare(a, b);
        }
        // If only one is "Process missing", we can reliably put it first
        return a[hiotName] === "Process missing" ? -1 : 1;
      };
      const data = response.data.data;
      setDropdown(
        [
          {
            dropdown: "Process missing",
            dropdown_en: "Process missing",
            unit: "N/A",
          },
          ...data,
        ]
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(customCompare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdComponentDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("prod-component-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-component-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // Backend returns items with isCategory flag for grouping
      // Format: { isCategory: true, name: "...", value: "...", category: "..." } for categories
      // Format: { id, name, value, category, unit, code, ... } for components
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          // Category header item
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          // Component item
          // Backend returns: dropdown (display name), subgroup (category), code (may be null)
          // Use dropdown for name, subgroup for category, code or id for value
          return {
            id: item.id,
            name: item.name || item.dropdown || item.dropdown_en || item.value, // Use dropdown field as name
            value:
              item.code || item.id?.toString() || item.value || item.dropdown, // Use code, id, or dropdown as value
            category: item.category || item.subgroup || item.subgroup_en, // Use subgroup as category
            unit: item.unit,
            code: item.code || item.id?.toString(), // Use code or id as code
            characterization_factors: item.characterization_factors,
            // Keep original fields for reference
            dropdown: item.dropdown,
            dropdown_en: item.dropdown_en,
            subgroup: item.subgroup,
            subgroup_en: item.subgroup_en,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductSpecificPackagingMaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-specific-packaging-material-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-specific-packaging-material-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // Backend returns items with isCategory flag for grouping
      // Format: { isCategory: true, name: "...", value: "...", category: "..." } for categories
      // Format: { id, name, value, category, unit, code, ... } for materials
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          // Category header item
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          // Material item
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name, // Use code as value for API calls
            category: item.category,
            unit: item.unit,
            code: item.code, // Keep code separate for reference
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportPackagingMaterialDropdown = ({
  setDropdown = function () {
    return;
  },
  flow = "31.2a", // Default to 31.2a if not specified
}) => {
  const _lcaKey = lcaCacheKeyTransportPackaging(flow);
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      `/api/business/product-transport-packaging-dropdown?flow=${flow}`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit,
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductWaterTypeDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-water-type-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-water-type-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // Backend returns items with isCategory flag for grouping
      // Format: { isCategory: true, name: "...", value: "...", category: "..." } for categories
      // Format: { id, name, value, category, unit, code, ... } for water types
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          // Category header item
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          // Water type item
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name, // Use code as value for API calls
            category: item.category,
            unit: item.unit || "m³", // Default to m³ if not specified
            code: item.code, // Keep code separate for reference
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

// Flow 31.4: Surplus Transport Dropdowns
export const getProductSurplusTransportDisposalMethodDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-surplus-transport-disposal-method-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-surplus-transport-disposal-method-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductSurplusTransportCountryDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-surplus-transport-country-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-surplus-transport-country-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      // Format country data to show name as value (not code)
      const formattedData = response.data.data.map((item) => ({
        id: item.id || item.code || item.name,
        name: item.name, // Display name (e.g., "Austria")
        value: item.name, // Use name as value for display (e.g., "Austria")
        code: item.code, // Keep code for API calls (e.g., "AU")
      }));
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.error("Error fetching country dropdown:", error);
      setDropdown([]);
    });
};

// Flow 31.5: Losses Material Dropdown
export const getProductLossesMaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-losses-material-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-losses-material-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

// ============================================
// Flow 32: Transport (A2) Dropdowns
// ============================================

// Flow 32.1: Transport Means Dropdown
export const getProductTransportMeansDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-transport-means-dropdown-32-1");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-transport-means-dropdown?flow=32.1",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "kgCO₂e/tkm",
            code: item.code,
            // Include all 16 impact category characterization factors
            // Use _factor fields if available, otherwise use direct fields
            global_warming:
              item.global_warming || item.global_warming_factor || 0,
            ozone_depletion:
              item.ozone_depletion || item.ozone_depletion_factor || 0,
            smog: item.smog || item.smog_factor || 0,
            acidification: item.acidification || item.acidification_factor || 0,
            eutrophication_terrestrial:
              item.eutrophication_terrestrial ||
              item.eutrophication_terrestrial_factor ||
              0,
            eutrophication_freshwater:
              item.eutrophication_freshwater ||
              item.eutrophication_freshwater_factor ||
              0,
            eutrophication_marine:
              item.eutrophication_marine ||
              item.eutrophication_marine_factor ||
              0,
            carcinogenics: item.carcinogenics || item.carcinogenics_factor || 0,
            non_carcinogenics:
              item.non_carcinogenics || item.non_carcinogenics_factor || 0,
            respiratory_effects:
              item.respiratory_effects || item.respiratory_effects_factor || 0,
            ecotoxicity: item.ecotoxicity || item.ecotoxicity_factor || 0,
            fossil_fuel_depletion:
              item.fossil_fuel_depletion ||
              item.fossil_fuel_depletion_factor ||
              0,
            land_use: item.land_use || item.land_use_factor || 0,
            water_use: item.water_use || item.water_use_factor || 0,
            resource_use_minerals_metals:
              item.resource_use_minerals_metals ||
              item.resource_use_minerals_metals_factor ||
              0,
            ionising_radiation:
              item.ionising_radiation || item.ionising_radiation_factor || 0,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.error("Error fetching transport means dropdown:", error);
      setDropdown([]);
    });
};

// Flow 32.1 & 32.2: Country Dropdown (shared with Flow 31)
export const getProductTransportCountryDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-transport-country-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-transport-country-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // Format country data to show name as value (not code)
      const formattedData = response.data.data.map((item) => ({
        id: item.id || item.code || item.name,
        name: item.name, // Display name (e.g., "Denmark")
        value: item.name, // Use name as value for display (e.g., "Denmark")
        code: item.code, // Keep code for API calls (e.g., "DK")
      }));
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

// Flow 32.1: Packaging from A1 Dropdown
export const getTransportPackagingFromA1Dropdown = ({
  productId,
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyProduct(
    productId,
    "transport-packaging-from-a1-dropdown",
  );
  if (_lcaKey && applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/transport-packaging-from-a1-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      // Backend provides: id, material, name, qty, value, unit, code, supplier, product_code
      const formattedData = response.data.data.map((item) => ({
        id: item.id,
        name: item.name || item.material, // Backend resolves name from dropdown
        value: item.value || item.qty, // Backend provides value (same as qty)
        code: item.code || item.material,
        qty: item.qty,
        unit: item.unit || "kg",
        material: item.material,
        supplier: item.supplier,
        product_code: item.product_code,
        // Display value for dropdown: "Material Name - Quantity unit"
        displayValue: `${item.name || item.material} - ${item.qty || 0} ${
          item.unit || "kg"
        }`,
      }));
      if (_lcaKey) writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.error("Error fetching packaging dropdown:", error);
      setDropdown([]);
    });
};

// ============================================
// Flow 33: Manufacturing Processes (LCA)
// ============================================

// Flow 33.1: Manufacturing Process Dropdown (categorized)
export const getProductManufacturingProcess33_1Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-manufacturing-process-33-1-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-manufacturing-process-33-1-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const data = response?.data?.data || [];
      const formatted = data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        }
        return {
          id: item.id,
          name: item.name,
          value: item.code || item.value || item.name, // code used for API calls
          category: item.category,
          unit: item.unit || "unit",
          code: item.code,
          conversion_factor_to_kg: item.conversion_factor_to_kg || 1,
          characterization_factors: item.characterization_factors,
          // optional direct impact factor fields if backend returns them
          global_warming:
            item.global_warming || item.global_warming_factor || 0,
          ozone_depletion:
            item.ozone_depletion || item.ozone_depletion_factor || 0,
          smog: item.smog || item.smog_factor || 0,
          acidification: item.acidification || item.acidification_factor || 0,
          eutrophication_terrestrial:
            item.eutrophication_terrestrial ||
            item.eutrophication_terrestrial_factor ||
            0,
          eutrophication_freshwater:
            item.eutrophication_freshwater ||
            item.eutrophication_freshwater_factor ||
            0,
          eutrophication_marine:
            item.eutrophication_marine ||
            item.eutrophication_marine_factor ||
            0,
          carcinogenics: item.carcinogenics || item.carcinogenics_factor || 0,
          non_carcinogenics:
            item.non_carcinogenics || item.non_carcinogenics_factor || 0,
          respiratory_effects:
            item.respiratory_effects || item.respiratory_effects_factor || 0,
          ecotoxicity: item.ecotoxicity || item.ecotoxicity_factor || 0,
          fossil_fuel_depletion:
            item.fossil_fuel_depletion ||
            item.fossil_fuel_depletion_factor ||
            0,
          land_use: item.land_use || item.land_use_factor || 0,
          water_use: item.water_use || item.water_use_factor || 0,
          resource_use_minerals_metals:
            item.resource_use_minerals_metals ||
            item.resource_use_minerals_metals_factor ||
            0,
          ionising_radiation:
            item.ionising_radiation || item.ionising_radiation_factor || 0,
        };
      });
      writeLcaDropdownCache(_lcaKey, formatted);
      setDropdown(formatted);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 33.2: Currency Dropdown (reuse existing business-travel dataset)
// No new API: uses GET /api/business/business-travel-country-data and extracts unique currencies.
export const getCurrencyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("currency-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/business-travel-country-data",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const data = response?.data?.data || [];
      const map = new Map();
      data.forEach((c) => {
        const code = c.currency_code;
        const name = c.currency_name;
        if (!code || !name) return;
        if (!map.has(code)) {
          map.set(code, {
            id: code,
            code,
            name,
            value: name,
            currency_code: code,
            currency_name: name,
          });
        }
      });
      const currencies = Array.from(map.values()).sort((a, b) =>
        (a.name || "").localeCompare(b.name || ""),
      );
      writeLcaDropdownCache(_lcaKey, currencies);
      setDropdown(currencies);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 32.2: Surplus Transport A2 Disposal Method Dropdown
export const getProductSurplusTransportA2DisposalMethodDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-surplus-transport-a2-disposal-method-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-surplus-transport-a2-disposal-method-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            // Include all 16 impact category characterization factors
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

// Flow 32.3: Losses A2 Material Dropdown
export const getProductLossesA2MaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-losses-a2-material-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-losses-a2-material-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            // Include all 16 impact category characterization factors
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdManufacturingProcessDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("prod-manufacturing-process-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-manufacturing-process-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdManufacturingMaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("prod-manufacturing-material-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-manufacturing-material-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdManufacturingWaterDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("prod-manufacturing-water-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-manufacturing-water-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdProductionMachineVehicleDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("prod-production-machine-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-production-machine-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdSurplusResourcesDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobalI18n("prod-surplus-resources-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-surplus-resources-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const _data = response.data.data
        .map((size) => {
          size.value = size[hiotName];
          size.name = size[hiotName];

          return size;
        })
        .sort(compare);
      writeLcaDropdownCache(_lcaKey, _data);
      setDropdown(_data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematPurchaseEnergy = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-purchased-energy-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematHomeEnergy = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-home-energy-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematSymbioticEnergy = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-symbiotic-energy-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematInventoryChemical = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-inventory-chemical-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare),
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

// ============================================
// Flow 34: Custom Manufacturing Dropdowns
// ============================================

// Flow 34.1a: Material Usage Dropdown
export const getProductMaterialUsage34_1aDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-material-usage-34-1a-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-material-usage-34-1a-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 34.1b: Packaging Usage Dropdown
export const getProductPackagingUsage34_1bDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-packaging-usage-34-1b-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-packaging-usage-34-1b-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            // Always prioritize name for display
            // If name doesn't exist, use value (assuming value is display name, not code)
            name: item.name || item.value || item.code,
            // Store code for backend API calls - this is what gets sent to the API
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 34.1c: Water Type Dropdown (specific to Flow 34.1c)
export const getProductWaterType34_1cDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-water-type-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-water-type-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "m³",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 34.2a: Production Machines Energy Dropdown
export const getProductProductionMachinesEnergy34_2aDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-production-machines-energy-34-2a-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-production-machines-energy-34-2a-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 34.2b: Production Vehicles Energy Dropdown
export const getProductProductionVehiclesEnergy34_2bDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-production-vehicles-energy-34-2b-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-production-vehicles-energy-34-2b-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 34.3: Surplus Resources Disposal Method Dropdown
export const getProductSurplusResourcesDisposal34_3Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-surplus-resources-disposal-34-3-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-surplus-resources-disposal-34-3-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            characterization_factors: item.characterization_factors,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 35: Material Lost Dropdown
export const getProductMaterialLost35Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-material-lost-35-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-material-lost-35-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 36: Transportation Means Dropdown
export const getProductTransportationMeans36Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-transportation-means-36-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-transportation-means-36-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "tkm",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 38: Transportation Means Dropdown
export const getProductTransportationMeans38Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-transportation-means-38-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-transportation-means-38-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "tkm",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 41.1c: Direct Emission Dropdown
export const getProductDirectEmission41_1cDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-direct-emission-41-1c-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-direct-emission-41-1c-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 41.2a: Energy Input During Maintenance Dropdown
export const getProductEnergyInputMaintenance41_2aDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-energy-input-maintenance-41-2a-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl + "/api/business/product-energy-input-maintenance-41-2a-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 41.2a: Water Consumption During Maintenance Dropdown
export const getProductWaterConsumptionMaintenance41_2aDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-water-consumption-maintenance-41-2a-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-water-consumption-maintenance-41-2a-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 41.2b: Current Disposal Method Dropdown
export const getProductDisposalMethodMaintenance41_2bDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-disposal-method-maintenance-41-2b-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-disposal-method-maintenance-41-2b-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 36: Packaging from Flow 34.1b Dropdown
export const getTransportPackagingFrom34_1bDropdown = ({
  productId,
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyProduct(
    productId,
    "transport-packaging-from-34-1b-dropdown",
  );
  if (_lcaKey && applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product/" +
      productId +
      "/transport-packaging-from-34-1b-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      // Backend provides: id, material, name, qty, value, unit, code, supplier
      const formattedData = response.data.data.map((item) => ({
        id: item.id,
        name: item.name || item.material,
        value: item.value || item.qty,
        code: item.code || item.material,
        qty: item.qty,
        unit: item.unit || "kg",
        material: item.material,
        supplier: item.supplier,
        // Display value for dropdown: "Material Name - Quantity unit"
        displayValue: `${item.name || item.material} - ${item.qty || 0} ${
          item.unit || "kg"
        }`,
      }));
      if (_lcaKey) writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.error(
        "Error fetching packaging dropdown from Flow 34.1b:",
        error,
      );
      setDropdown([]);
    });
};

// Flow 37.1: Material/Energy Usage Dropdown
export const getProductInstallationMaterial37_1Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-installation-material-37-1-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-installation-material-37-1-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 37.2: Disposal Method Dropdown
export const getProductInstallationDisposal37_2Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-installation-disposal-37-2-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-installation-disposal-37-2-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 37.4: Material Lost Dropdown
export const getProductInstallationMaterialLost37_4Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-installation-material-lost-37-4-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-installation-material-lost-37-4-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 43.1: Means of Transportation Dropdown
export const getProductFlow43_1MeansOfTransportationDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-flow-43-1-means-of-transportation-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/product-flow-43-1-means-of-transportation-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 43.1: Packaging per FU Dropdown (used by 43.1, 43.2, 43.3)
export const getProductFlow43_1PackagingPerFUDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-flow-43-1-packaging-per-fu-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-43-1-packaging-per-fu-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 43.4: Disposal Method Dropdown
export const getProductFlow43_4DisposalMethodDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-flow-43-4-disposal-method-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-43-4-disposal-method-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 44.1: Processed Dropdown
export const getProductFlow44_1ProcessedDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-flow-44-1-processed-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-44-1-processed-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 44.1: Next Waste Process Scenario Dropdown
export const getProductFlow44_1NextWasteDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-flow-44-1-next-waste-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-44-1-next-waste-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            code: item.code,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 41.6: Material Dropdown
export const getProductFlow41_6Dropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-flow-41-6-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-41-6-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 45.1: How is the part disposed Dropdown
export const getProductFlow45_1DisposedDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-flow-45-1-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-45-1-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 45.2: Material Dropdown
export const getProductFlow45_2MaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-flow-45-2-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-45-2-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 46: Material Dropdown (What material do we prevent the purchase of)
export const getProductFlow46MaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal("product-flow-46-dropdown");
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-46-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming: item.global_warming,
            ozone_depletion: item.ozone_depletion,
            smog: item.smog,
            acidification: item.acidification,
            eutrophication_terrestrial: item.eutrophication_terrestrial,
            eutrophication_freshwater: item.eutrophication_freshwater,
            eutrophication_marine: item.eutrophication_marine,
            carcinogenics: item.carcinogenics,
            non_carcinogenics: item.non_carcinogenics,
            respiratory_effects: item.respiratory_effects,
            ecotoxicity: item.ecotoxicity,
            fossil_fuel_depletion: item.fossil_fuel_depletion,
            land_use: item.land_use,
            water_use: item.water_use,
            resource_use_minerals_metals: item.resource_use_minerals_metals,
            ionising_radiation: item.ionising_radiation,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 46: Name Part in FU Dropdown (from Flow 44.1 and 45.1)
export const getProductFlow46NamePartInFUDropdown = ({
  productId,
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyProduct(
    productId,
    "flow-46-name-part-in-fu-dropdown",
  );
  if (_lcaKey && applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url:
      baseUrl +
      `/api/business/product/${productId}/flow-46-name-part-in-fu-dropdown`,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      // Format as simple dropdown options (not categorized)
      const formattedData = (response.data.data || []).map((item) => ({
        id: item.id || item.value || item.name,
        name: item.name || item.value,
        value: item.name || item.value,
      }));
      if (_lcaKey) writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};

// Flow 42.1: Material/Energy Dropdown
export const getProductFlow42_1MaterialEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const _lcaKey = lcaCacheKeyGlobal(
    "product-flow-42-1-material-energy-dropdown",
  );
  if (applyLcaDropdownCache(_lcaKey, setDropdown)) return;

  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-flow-42-1-material-energy-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (!response.data || !response.data.data) {
        console.error("Invalid API response structure:", response.data);
        setDropdown([]);
        return;
      }
      const formattedData = response.data.data.map((item) => {
        if (item.isCategory) {
          return {
            isCategory: true,
            name: item.name || item.value || item.category,
            value: item.value || item.name || item.category,
            category: item.category || item.name || item.value,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            value: item.code || item.value || item.name,
            category: item.category,
            unit: item.unit || "unit",
            code: item.code,
            global_warming_factor: item.global_warming_factor,
            ozone_depletion_factor: item.ozone_depletion_factor,
            smog_factor: item.smog_factor,
            acidification_factor: item.acidification_factor,
            eutrophication_terrestrial_factor:
              item.eutrophication_terrestrial_factor,
            eutrophication_freshwater_factor:
              item.eutrophication_freshwater_factor,
            eutrophication_marine_factor: item.eutrophication_marine_factor,
            carcinogenics_factor: item.carcinogenics_factor,
            non_carcinogenics_factor: item.non_carcinogenics_factor,
            respiratory_effects_factor: item.respiratory_effects_factor,
            ecotoxicity_factor: item.ecotoxicity_factor,
            fossil_fuel_depletion_factor: item.fossil_fuel_depletion_factor,
            land_use_factor: item.land_use_factor,
            water_use_factor: item.water_use_factor,
            resource_use_minerals_metals_factor:
              item.resource_use_minerals_metals_factor,
            ionising_radiation_factor: item.ionising_radiation_factor,
          };
        }
      });
      writeLcaDropdownCache(_lcaKey, formattedData);
      setDropdown(formattedData);
    })
    .catch(function (error) {
      console.log(error);
      setDropdown([]);
    });
};
